'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Recaptcha = require('./Recaptcha');

var _Recaptcha2 = _interopRequireDefault(_Recaptcha);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Recaptcha2.default;